module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.header.title) { ;
__p += '\n<div title="' +
((__t = ( data.header.title )) == null ? '' : __t) +
'" data-toggle="tooltip">' +
((__t = ( data.name )) == null ? '' : __t) +
'</div>\n';
 } else { ;
__p += '\n<div>' +
((__t = ( data.name )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
return __p
}